import React, { Component } from 'react'
import PropTypes from 'prop-types'

import '../styles/Button.css'

class Button extends Component {
  render () {
    const label = this.props.label.split(' - ')

    return (
      <div className='Button white'>
        {label.map((label) => {
          return (
            <div key={label}>
              <span className='grommetux-button__label'>{label}</span>
            </div>
          )
        })}
      </div>
    )
  }
}

Button.propTypes = {
  label: PropTypes.string,
  primary: PropTypes.bool
}

export default Button



// WEBPACK FOOTER //
// ./src/components/FauxButton.js